module.exports = __webpack_public_path__ + "img/star2.d2bff828.svg";